module.exports = __webpack_public_path__ + "static/linkedin-abf6b5a1f0a041570859c3c5e59b1880.png";